// pages/RefundPolicy.js
export default function PrivacyPolicy() {
return (
    <div className="max-w-3xl mx-auto p-6 font-sans text-primary">
      <h1 className="text-3xl font-heading font-bold mb-4">Refund & Cancellation Policy</h1>

      <p className="mb-4">
        At ZollowUp, we aim to provide reliable and satisfactory services. However, if you are not satisfied or need to cancel a service, please refer to our policy below.
      </p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">1. Cancellation Policy</h2>
      <p>
        You may cancel a booking up to 24 hours in advance to receive a full refund. Cancellations within 24 hours of the scheduled service may incur a 30% cancellation fee.
      </p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">2. Refund Policy</h2>
      <p>
        If our service provider fails to arrive or the service is incomplete due to our fault, you are eligible for a full refund. Partial refunds may be issued in other cases upon review.
      </p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">3. Refund Process</h2>
      <p>
        Refunds will be processed within 7–10 business days to your original payment method. Please contact <span className="text-accent">support@zollowup.com</span> with your booking ID.
      </p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">4. Special Cases</h2>
      <p>
        In exceptional scenarios (such as natural disasters or emergencies), we may waive cancellation charges or offer full refunds at our discretion.
      </p>

      <h2 className="text-xl font-heading font-semibold mt-6 mb-2">5. Contact Us</h2>
      <p>
        Email: <span className="text-accent">sales@zollowup.com</span> <br />
        Phone: +91 9267987940
      </p>
    </div>
  );


}